// extracted by mini-css-extract-plugin
export default {"cls1":"nlFnvUednlIfX6NCZPdk","cls2":"WUTtME4CiGJPtJcYoH8Q nlFnvUednlIfX6NCZPdk"};